module.exports = __webpack_public_path__ + "static/media/UserLogo.4d8eb7f2.png";